
import React from "react";
import { Input } from "@/components/ui/input";
import { useForm } from "@/context/FormContext";
import { FormFieldType } from "@/types/form";
import FieldWrapper from "./FieldWrapper";

interface UrlFieldProps {
  element: FormFieldType;
}

export const UrlField: React.FC<UrlFieldProps> = ({ element }) => {
  const { formData, setField } = useForm();
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setField(element.name!, e.target.value);
  };

  return (
    <FieldWrapper element={element}>
      <Input
        id={element.id}
        type="url"
        placeholder={element.placeholder || ""}
        value={(formData[element.name!] as string) || ""}
        onChange={handleChange}
        className="w-full"
        required={element.required}
      />
    </FieldWrapper>
  );
};

export default UrlField;
